export default class DateUtils {
  static convertMinutesToMiliseconds = (minutes: number): number => minutes * 60 * 1000;

  static getFormattedDateFromString = (date: string, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(new Date(date));
  };

  static getFormattedDate = (date: Date, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
  };

}
